<div>
    <div class="master-properties" appFullHigh [bottomOffset]=200>
        <div class="master-header">
            @if (mode === 'edit') {
            <h2>{{'upload.editFiles' | translate}}</h2>
            } @else {
            <h2>{{'upload.uploadFiles' | translate}}</h2>
            }
            <span class="icons">
                <mat-slide-toggle (change)="toggleAdditive($event)">{{'upload.properties.add' | translate }}</mat-slide-toggle>
                @if(isPropertyVisibleALL) {
                    <button mat-icon-button (click)="toggleAllVisibilities()" matTooltip="{{'upload.hideAllProperties' | translate }}">
                        <mat-icon fontIcon="visibility"></mat-icon>
                    </button>
                } @else {
                    <button mat-icon-button (click)="toggleAllVisibilities()" matTooltip="{{'upload.showAllProperties' |translate}}">
                        <mat-icon fontIcon="visibility_off"></mat-icon>
                    </button>
                }

                     <button mat-icon-button (click)="clearAllValues()">
                        <mat-icon fontIcon="delete"></mat-icon>
                    </button>
            </span>
        </div>
        <div class="master-properties-form" [formGroup]="propertiesForm">
            @for (prop of eligibleProperties; track prop.name) {
                <div class="master-property">
                    @if (prop.type === 'boolean') {
                        <mat-checkbox [formControlName]="prop.name">
                            {{ 'property.' + prop.name|translate }}
                            @if (prop.hint) {
                                <mat-icon matTooltip="{{ prop.hint | translate }}" inline>info</mat-icon>
                            }
                        </mat-checkbox>
                    } @else {
                    <mat-form-field >
                        <mat-label>
                            {{ 'property.' + prop.name|translate }}
                            @if (prop.validation?.required) {
                                <span class="required">*</span>
                            }
                            @if (prop.hint) {
                                <mat-icon matTooltip="{{ prop.hint | translate }}">info</mat-icon>
                            }
                        </mat-label>
                        @if (prop.type === 'checkbox') {
                            <mat-select [formControlName]="prop.name" multiple>
                                @for (option of prop["values"]; track option.value) {
                                    @let usage = propertyUsages[prop.name][option.value];
                                    <mat-option [value]="option.value">
                                        {{ 'property.' + prop.name + '.' + option.value | translate }}
                                        @if (usage) {
                                            ({{ usage }})
                                        }
                                    </mat-option>
                                }
                            </mat-select>

                        } @else if (prop.type === 'textarea') {
                            <textarea matInput [formControlName]="prop.name"></textarea>
                        } @else {
                            @if (prop.isMultiple) {
                                <input matInput [formControlName]="prop.name" (keyup)="onMultiValueKeyUp($event)">
                            } @else {
                                <input matInput [formControlName]="prop.name">
                            }
                        }
                    </mat-form-field>
                    }
                    <span class="icons">
                         <button mat-icon-button (click)="toggleVisibility(prop)">
                            <mat-icon fontIcon="{{ isPropertyVisible(prop) ? 'visibility' : 'visibility_off' }}"></mat-icon>
                        </button>
                         <button mat-icon-button (click)="clearValue(prop)">
                            <mat-icon fontIcon="delete"></mat-icon>
                        </button>
                    </span>

                </div>
            }
        </div>
        <div class="master-collection-form" [formGroup]="collectionForm">
            <div class="master-property">
                <mat-form-field>
                    <mat-label> {{ 'upload.properties.collection' | translate }}</mat-label>
                    <input matInput [matAutocomplete]="auto" formControlName="search">
                </mat-form-field>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCollection($event)" [displayWith]="displayFn" >
                    @for (coll of collections; track coll.uuid) {
                        <mat-option [value]="coll">
                            <span>{{coll.name}}</span>
                        </mat-option>
                    }
                </mat-autocomplete>
                <span class="icons">
                     <button mat-icon-button (click)="clearCollection()">
                        <mat-icon fontIcon="delete"></mat-icon>
                    </button>
                </span>
            </div>
        </div>
    </div>
</div>
